import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import UserAgreement from './pages/UserAgreement';
import SocioEconomicProfile from './pages/SocioEconomicProfile';
import Visa from './pages/Visa';
//import Sectoral from './pages/Sectoral';
import PublicationSchedule from './pages/PublicationSchedule';
import RecruitmentPage from './pages/RecruitmentPage';
import OngoingSurveysPage from './pages/OngoingSurveysPage';
import NewsState from './pages/NewsState';
import Bulletin from './pages/Bulletin';
import Mercuriale from './pages/Mercuriale';
import Indice from './pages/Indice';
import  IndicateurDHD from './pages/IndicateurDHD';
import  Rapport from './pages/Rapport';
import  IndicateurODD from './pages/IndicateurODD';
import  PropDemographique from './pages/PropDemographique';
import  ProjectionGroupeAgeQuin from './pages/ProjectionGroupeAgeQuin';
import  ProjectionAgeSpecifique from './pages/ProjectionAgeSpecifique';
import  Recensement from './pages/Recensement';
import  RecensementCafe from './pages/RecensementCafe';
import  EnquenteSanteDemographe from './pages/EnquenteSanteDemographe';
import  EnqueteCommerceTransportEntreprise from './pages/EnqueteCommerceTransportEntreprise';
import Aao from './opportinuty/Aao';
import  EnqueteMenage from './pages/EnqueteMenage';
import  EnqueteAgricole from './pages/EnqueteAgricole';
import  EnqueteNutrition from './pages/EnqueteNutrition';
import  RapportProjectPopulation from './pages/RapportProjectPopulation';
import  BulletinCommerceExterieur from './pages/BulletinCommerceExterieur';
import  BulletinConjoncture from './pages/BulletinConjoncture';
import  BulletinsEtatCivil from './pages/BulletinsEtatCivil';
import  BulletinsPrix from './pages/BulletinsPrix';
import  BulletinsStatistiques from './pages/BulletinsStatistiques';
import  NotesConjoncture from './pages/NotesConjoncture';
import  CahiersINSBU from './pages/CahiersINSBU';
import  ComptesNationaux from './pages/ComptesNationaux';
import  IndicesPrixConsommation from'./pages/IndicesPrixConsommation';
import  IndiceChiffreAffaires from'./pages/IndiceChiffreAffaires';
import  IndicesHarmonisesProductionIndustrielle from'./pages/IndicesHarmonisesProductionIndustrielle';
import  IndiceCoutConstruction from'./pages/IndiceCoutConstruction';
import  IndicesCommerceExterieur from'./pages/IndicesCommerceExterieur';
import  IndicePrixProductionAgricole from'./pages/IndicePrixProductionAgricole';
import  MinistereFonctionPublique from'./pages/MinistereFonctionPublique';
import  MinistereSante from'./pages/MinistereSante';
import  MinistereEAC from'./pages/MinistereEAC';
import  MinistereJustice from'./pages/MinistereJustice';
import  MinistereInfrastructures from'./pages/MinistereInfrastructures';
import  MinistereCommunication from'./pages/MinistereCommunication';
import  MinistereCommerce from'./pages/MinistereCommerce';
import  MinistereEducation from'./pages/MinistereEducation';
import  MinistereInterieur from'./pages/MinistereInterieur';
import  MinistereSolidaire from'./pages/MinistereSolidaire';
import  MinistereAgriculture  from'./pages/MinistereAgriculture';
import  MiniHdraulique  from'./pages/MiniHdraulique';
import  Sectoral  from'./pages/Ministeres';
import  PublicationsMensuel  from'./pages/PublicationsMensuel';
import   PublicationsTrimestrielles  from'./pages/PublicationsTrimestrielles';
import   Bibliotheque  from'./pages/Bibliotheque';
import   EsperanceVie  from'./pages/EsperanceVie';
import   ApercuINSBU  from'./pages/ApercuINSBU';
import   HistoriqueINSBU  from'./pages/HistoriqueINSBU';
import   CoordinationSSN  from'./pages/CoordinationSSN';
import   LegalFramework  from'./pages/LegalFramework';
import   Ordinances  from'./pages/Ordinances';
import   Decrees  from'./pages/Decrees';
import   PageCodes  from'./pages/PageCodes';
import   DocumentINSBU  from'./pages/DocumentINSBU';
import   PopulationStatistique  from'./pages/PopulationStatistique';
import   PIB  from'./pages/PIB';
import   IPC  from'./pages/IPC';
import   BulletinRecent  from'./pages/BulletinRecent';
import   IndiceRecent  from'./pages/IndiceRecent';
import   IcclbRecent  from'./pages/IcclbRecent';
import   AnnuaireStatistiquesEnvironnementales  from'./pages/AnnuaireStatistiquesEnvironnementales';
import   ParcAutomobile  from'./pages/ParcAutomobile';
import   TableauBordSocial  from'./pages/TableauBordSocial';
import   AnnuaireCommerceExterieur  from'./pages/AnnuaireCommerceExterieur';
import   AnnuaireStatistiquesAgricoles  from'./pages/AnnuaireStatistiquesAgricoles';
import   AnnuaireBulletinConjoncturel  from'./pages/AnnuaireBulletinConjoncturel';
import   AnnuaireStatistiqueTourisme  from'./pages/AnnuaireStatistiqueTourisme';
import   AnnuaireStatistique from './pages/AnnuaireStatistique';
import   Annuaires from './pages/Annuaires';
import   ContactUs from './pages/ContactUs';
import   ResultatRGPHAE2024 from './pages/ResultatRGPHAE2024';
import   ComptesEnergie from './pages/ComptesEnergie';
import   CalendarTable from './pages/CalendarTable';
import   RGPHAEDataPage from './pages/RGPHAEDataPage';
import   PopulationDataPage from './pages/PopulationDataPage';
import   PopulationCollectiveHouseholdsPage from './pages/PopulationCollectiveHouseholdsPage';
import   HomelessPopulationPage from './pages/HomelessPopulationPage';
import   PopulationResidentPage from './pages/PopulationResidentPage';
import   PopulationDataPageM from './pages/PopulationDataPageM';
import   MasculinityRatioPage from './pages/MasculinityRatioPage';
import   PopulationDataPageAge from './pages/PopulationAgeGroupPage';
import   PopulationAgeGroupPageGrand from './pages/PopulationAgeGroupPageGrand';
import   PopulationByAgeGroupPage from './pages/PopulationByAgeGroupPage';
import   AgeGroupPopulationPage from './pages/AgeGroupPopulationPage';
import   AdultPopulationPage from './pages/AdultPopulationPage';
//import   AdultPopulationPage from './pages/AdultPopulationPage';
import   AgriculturalHouseholdsPage from './pages/AgriculturalHouseholdsPage';
import   AgriculturalHouseholdsPages from './pages/AgriculturalHouseholdsPages';
import   AgriculturalHouseholdsPage20 from './pages/AgriculturalHouseholdsPage20';
import   FarmingHouseholdsPage from './pages/FarmingHouseholdsPage';

import   PoultryFarmingPage from './pages/PoultryFarmingPage';
import   InsectFarmingHouseholdsPage from './pages/InsectFarmingHouseholdsPage';
import   LivestockDistributionPage from './pages/LivestockDistributionPage';
import   PoultryDistributionPage from './pages/PoultryDistributionPage';
import   AgriculturalEquipmentPage from './pages/AgriculturalEquipmentPage';
import   BeekeepingHouseholdsPage from './pages/BeekeepingHouseholdsPage';
import   FishingHouseholdsPage from './pages/FishingHouseholdsPage';
import   AssociationInterventionPage from './pages/AssociationInterventionPage';
import   CooperativeInterventionPage from './pages/CooperativeInterventionPage';
import   InterventionProjectsPage from './pages/InterventionProjectsPage';
import   HousingDistributionPage from './pages/HouseholdHousingPage';
import   RoofMaterialPage from './pages/RoofMaterialPage';
import   HousingMaterialPage from './pages/HousingMaterialPage';
import   AgriculturalHouseholdsPageProvCom from './pages/AgriculturalHouseholdsPageProvCom';
import   PopulationAgeResidencePage from './pages/PopulationAgeResidencePage';
import   EnqueteSatisfaction from './pages/EnqueteSatisfaction';
import   PopulationDataPageBuhumuzaButaganzwa from './pages/PopulationDataPageBuhumuzaButaganzwa';
import   PopulationDataPageBuhumuzaButihinda from './pages/PopulationDataPageBuhumuzaButihinda';
import   PopulationDataPageBuhumuza from './pages/PopulationDataPageBuhumuza';
import   PopulationDataPageBujumbura from './pages/PopulationDataPageBujumbura';
import   PopulationDataPageBurunga from './pages/PopulationDataPageBurunga';
import   PopulationDataPageButanyerera from './pages/PopulationDataPageButanyerera';
import   PopulationDataPageGitega from './pages/PopulationDataPageGitega';
import   PopulationDataPageBuhumuzaCankuzo from './pages/PopulationDataPageBuhumuzaCankuzo';
import   PopulationDataPageBuhumuzaGisagara from './pages/PopulationDataPageBuhumuzaGisagara';
import   PopulationDataPageBuhumuzaGisuru from './pages/PopulationDataPageBuhumuzaGisuru';
import   PopulationDataPageBuhumuzaRuyigi from './pages/PopulationDataPageBuhumuzaRuyigi';
import   PopulationDataPageBujumburaBubanza from './pages/PopulationDataPageBujumburaBubanza';
import   PopulationDataPageBuhumuzaMuyinga from './pages/PopulationDataPageBuhumuzaMuyinga';
import   PopulationDataPageBujumburaCibitoke from './pages/PopulationDataPageBujumburaCibitoke';
import   PopulationDataPageBujumburaIsare from './pages/PopulationDataPageBujumburaIsare';
import   PopulationDataPageBujumburaMpanda from './pages/PopulationDataPageBujumburaMpanda';
import   PopulationDataPageBujumburaMugina from './pages/PopulationDataPageBujumburaMugina';
import   PopulationDataPageBujumburaBukinanyana from './pages/PopulationDataPageBujumburaBukinanyana';
import   PopulationDataPageBujumburaMugere from './pages/PopulationDataPageBujumburaMugere';
import   PopulationDataPageBujumburaMuhuta from './pages/PopulationDataPageBujumburaMuhuta';
import   PopulationDataPageBujumburaMukaza from './pages/PopulationDataPageBujumburaMukaza';
import   PopulationDataPageBujumburaNtahangwa from './pages/PopulationDataPageBujumburaNtahangwa';
import   PopulationDataPageBujumburaRwibaga from './pages/PopulationDataPageBujumburaRwibaga';
import   PopulationDataPageBurungaBururi from './pages/PopulationDataPageBurungaBururi';
import   PopulationDataPageBurungaMakamba from './pages/PopulationDataPageBurungaMakamba';
import   PopulationDataPageBurungaMatana from './pages/PopulationDataPageBurungaMatana';
import   PopulationDataPageBurungaMusongati from './pages/PopulationDataPageBurungaMusongati';
import   PopulationDataPageBurungaNyanza from './pages/PopulationDataPageBurungaNyanza';
import   PopulationDataPageBurungaRumonge from './pages/PopulationDataPageBurungaRumonge';
import   PopulationDataPageBurungaRutana from './pages/PopulationDataPageBurungaRutana';
import   PopulationDataPageButanyereraBusoni from './pages/PopulationDataPageButanyereraBusoni';
import   PopulationDataPageButanyereraKayanza from './pages/PopulationDataPageButanyereraKayanza';
import   PopulationDataPageButanyereraKiremba from './pages/PopulationDataPageButanyereraKiremba';
import   PopulationDataPageButanyereraKirundo from './pages/PopulationDataPageButanyereraKirundo';
import   PopulationDataPageButanyereraMatongo from './pages/PopulationDataPageButanyereraMatongo';
import   PopulationDataPageButanyereraMuhanga from './pages/PopulationDataPageButanyereraMuhanga';
import   PopulationDataPageButanyereraNgozi from './pages/PopulationDataPageButanyereraNgozi';
import   PopulationDataPageButanyereraTangara from './pages/PopulationDataPageButanyereraTangara';
import   PopulationDataPageGitegaBugendana from './pages/PopulationDataPageGitegaBugendana';
import   PopulationDataPageGitegaGishubi from './pages/PopulationDataPageGitegaGishubi';
import   PopulationDataPageGitegaGitega from './pages/PopulationDataPageGitegaGitega';
import   PopulationDataPageGitegaKarusi from './pages/PopulationDataPageGitegaKarusi';
import   PopulationDataPageGitegaKiganda from './pages/PopulationDataPageGitegaKiganda';
import   PopulationDataPageGitegaMwaro from './pages/PopulationDataPageGitegaMwaro';
import   PopulationDataPageGitegaNyabihanga from './pages/PopulationDataPageGitegaNyabihanga';
import   PopulationDataPageGitegaShombo from './pages/PopulationDataPageGitegaShombo';
import  PopulationDataPageGitegaMuramvya from './pages/PopulationDataPageGitegaMuramvya';
import  PopulationDataPageBurundi from './pages/PopulationDataPageBurundi';
import  RapportPaysSoutien from './pages/RapportPaysSoutien';
import RapportsBilansAlimentaires from './pages/RapportsBilansAlimentaires';
import MoisStatistique2025 from './pages/MoisStatistique2025';
import RapportModulesAgricoles from './pages/RapportModulesAgricoles';
import DocumentsInfographies from './pages/DocumentsInfographies';
import SuiviIndicateurs from './pages/SuiviIndicateurs';
import Data from './pages/Data';
import ClotureMoisStatistique2025 from './pages/ClotureMoisStatistique2025';
import ActualitesEtEvenements from './pages/ActualitesEtEvenements';
import LancementMoisStatistique2025 from './pages/LancementMoisStatistique2025';
import CafeStatistiqueRGPH_RGAE from './pages/CafeStatistiqueRGPH_RGAE';
import PremierCongresEtudiantsStatistique from'./pages/PremierCongresEtudiantsStatistique';
import FormaFormationPage from'./pages/FormationPage';
import CommuniquesPresse from './pages/CommuniquesPresse';
import OdinPage from './pages/OdinPage';
import MissionCommunicationPage from './pages/MissionCommunicationPage';
import FormationEnqueteursPage from './pages/FormationEnqueteursPage';
import VisitLogger from './components/VisitLogger';
import PNDIndicators from './pages/PNDIndicators';
import ODDIndicators from './pages/ODDIndicators';
import InfographiePage from './pages/InfographiePage';
import AtelierValidationPage from './pages/AtelierValidationPage';




function App() { 
  return (
    <BrowserRouter>
     <VisitLogger />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/userAgreement" element={<UserAgreement />} />
        <Route path="/socioEconomicProfile" element={<SocioEconomicProfile />} />
        <Route path="/publicationSchedule" element={<PublicationSchedule />} />
        <Route path="/aao" element={<Aao />} />
        <Route path="/recruitmentPage" element={<RecruitmentPage />} />
        <Route path="/ongoingSurveysPage" element={<OngoingSurveysPage />} />
        <Route path="/bulletin" element={<Bulletin />} />
        <Route path="/newsState" element={<NewsState />} />
        <Route path="/indice" element={<Indice />} />
        <Route path="/mercuriale" element={<Mercuriale />} />
        <Route path="/indicateurDHD" element={<IndicateurDHD />} />
        <Route path="/indicateurODD" element={<IndicateurODD />} />
        <Route path="/rapport" element={<Rapport />} />
        <Route path="/propDemographique" element={<PropDemographique />} />
        <Route path="/projectionGroupeAgeQuin" element={<ProjectionGroupeAgeQuin />} />
        <Route path="/projectionAgeSpecifique" element={<ProjectionAgeSpecifique />} />
        <Route path="/recensement" element={<Recensement />} />
        <Route path="/recensementCafe" element={<RecensementCafe />} />
        <Route path="/enquenteSanteDemographe" element={<EnquenteSanteDemographe />} />
        <Route path="/enqueteCommerceTransportEntreprise" element={<EnqueteCommerceTransportEntreprise />} />
        <Route path="/enqueteMenage" element={<EnqueteMenage />} />
        <Route path="/enqueteAgricole" element={<EnqueteAgricole />} />
        <Route path="/enqueteNutrition" element={<EnqueteNutrition />} />
        <Route path="/rapportProjectPopulation" element={<RapportProjectPopulation />} />
        <Route path="/bulletinCommerceExterieur" element={<BulletinCommerceExterieur />} />
        <Route path="/bulletinConjoncture" element={<BulletinConjoncture />} />
        <Route path="/bulletinsEtatCivil" element={<BulletinsEtatCivil />} />
        <Route path="/bulletinsPrix" element={<BulletinsPrix />} />
        <Route path="/bulletinsStatistiques" element={<BulletinsStatistiques />} />
        <Route path="/notesConjoncture" element={<NotesConjoncture />} />
        <Route path="/cahiersINSBU" element={<CahiersINSBU />} />
        <Route path="/comptesNationaux" element={<ComptesNationaux />} />
        <Route path="/indicesPrixConsommation" element={<IndicesPrixConsommation />} /> 
        <Route path="/indiceChiffreAffaires" element={<IndiceChiffreAffaires />} /> 
        <Route path="/indicesHarmonisesProductionIndustrielle" element={<IndicesHarmonisesProductionIndustrielle />} /> 
        <Route path="/indiceCoutConstruction" element={<IndiceCoutConstruction />} /> 
        <Route path="/indicesCommerceExterieur" element={<IndicesCommerceExterieur />} /> 
        <Route path="/indicePrixProductionAgricole" element={<IndicePrixProductionAgricole />} />
        <Route path="/MinistereFonctionPublique" element={<MinistereFonctionPublique />} /> 
        <Route path="/MinistereSante" element={<MinistereSante />} /> 
        <Route path="/MinistereEAC" element={<MinistereEAC />} /> 
        <Route path="/MinistereAgriculture" element={<MinistereAgriculture />} /> 
        <Route path="/MinistereJustice" element={<MinistereJustice />} /> 
        <Route path="/MinistereInfrastructures" element={<MinistereInfrastructures />} /> 
        <Route path="/MinistereCommunication" element={<MinistereCommunication />} /> 
        <Route path="/MinistereCommerce" element={<MinistereCommerce />} /> 
        <Route path="/MinistereEducation" element={<MinistereEducation />} /> 
        <Route path="/MinistereInterieur" element={<MinistereInterieur />} /> 
        <Route path="/MinistereSolidaire" element={<MinistereSolidaire />} /> 
        <Route path="/miniHdraulique" element={<MiniHdraulique />} />   
        <Route path="/sectoral" element={<Sectoral />} /> 
        <Route path="/publicationsMensuel" element={<PublicationsMensuel />} /> 
        <Route path="/publicationsTrimestrielles" element={<PublicationsTrimestrielles />} /> 
        <Route path="/bibliotheque" element={<Bibliotheque />} /> 
        <Route path="/esperanceVie" element={<EsperanceVie />} /> 
        <Route path="/apercuINSBU" element={<ApercuINSBU />} /> 
        <Route path="/historiqueINSBU" element={<HistoriqueINSBU />} /> 
        <Route path="/coordinationSSN" element={<CoordinationSSN />} /> 
        <Route path="/legalFramework" element={<LegalFramework />} /> 
        <Route path="/ordinances" element={<Ordinances />} /> 
        <Route path="/decrees" element={<Decrees />} /> 
        <Route path="/pageCodes" element={<PageCodes />} /> 
        <Route path="/documentINSBU" element={<DocumentINSBU />} /> 
        <Route path="/populationStatistique" element={<PopulationStatistique />} /> 
        <Route path="/pIB" element={<PIB />} /> 
        <Route path="/iPC" element={<IPC />} /> 
        <Route path="/bulletinRecent" element={<BulletinRecent />} /> 
        <Route path="/indiceRecent" element={<IndiceRecent />} /> 
        <Route path="/icclbRecent" element={<IcclbRecent />} /> 
        <Route path="/annuaireStatistiquesEnvironnementales" element={<AnnuaireStatistiquesEnvironnementales />} /> 
        <Route path="/parcAutomobile" element={<ParcAutomobile />} /> 
        <Route path="/tableauBordSocial" element={<TableauBordSocial />} /> 
        <Route path="/annuaireCommerceExterieur" element={<AnnuaireCommerceExterieur />} /> 
        <Route path="/annuaireStatistiquesAgricoles" element={<AnnuaireStatistiquesAgricoles />} /> 
        <Route path="/annuaireBulletinConjoncturel" element={<AnnuaireBulletinConjoncturel />} /> 
        <Route path="/annuaireStatistiqueTourisme" element={<AnnuaireStatistiqueTourisme />} /> 
        <Route path="/annuaireStatistique" element={<AnnuaireStatistique />} />
        <Route path="/annuaire" element={<Annuaires />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/resultatRGPHAE2024" element={<ResultatRGPHAE2024 />} />
        <Route path="/comptesEnergie" element={<ComptesEnergie />} />
         <Route path="/calendarTable" element={<CalendarTable  />} />
        <Route path="/RGPHAEDataPage" element={<RGPHAEDataPage  />} />
        <Route path="/PopulationDataPage" element={<PopulationDataPage  />} />
        <Route path="/PopulationCollectiveHouseholdsPage" element={<PopulationCollectiveHouseholdsPage  />} />
        <Route path="/HomelessPopulationPage" element={<HomelessPopulationPage  />} />
        <Route path="/PopulationResidentPage" element={<PopulationResidentPage  />} />
        <Route path="/PopulationDataPageM" element={<PopulationDataPageM  />} />
        <Route path="/MasculinityRatioPage" element={<MasculinityRatioPage  />} />
        <Route path="/PopulationDataPageAge" element={<PopulationDataPageAge  />} />
        <Route path="/PopulationAgeGroupPageGrand" element={<PopulationAgeGroupPageGrand  />} />
        <Route path="/PopulationByAgeGroupPage" element={<PopulationByAgeGroupPage  />} />
        <Route path="/AgeGroupPopulationPage" element={<AgeGroupPopulationPage  />} />
        <Route path="/AdultPopulationPage" element={<AdultPopulationPage  />} />
        <Route path="/AgriculturalHouseholdsPage" element={<AgriculturalHouseholdsPage  />} />
        <Route path="/AgriculturalHouseholdsPages" element={<AgriculturalHouseholdsPages  />} />
        <Route path="/AgriculturalHouseholdsPage20" element={<AgriculturalHouseholdsPage20  />} />
        <Route path="/FarmingHouseholdsPage" element={<FarmingHouseholdsPage  />} />
          <Route path="/poultryFarmingPage" element={<PoultryFarmingPage  />} />
          <Route path="/insectFarmingHouseholdsPage" element={<InsectFarmingHouseholdsPage  />} />
          <Route path="/livestockDistributionPage" element={<LivestockDistributionPage  />} />
          <Route path="/poultryDistributionPage" element={<PoultryDistributionPage  />} />
          <Route path="/agriculturalEquipmentPage" element={<AgriculturalEquipmentPage  />} />
          <Route path="/beekeepingHouseholdsPage" element={<BeekeepingHouseholdsPage  />} />
          <Route path="/fishingHouseholdsPage" element={<FishingHouseholdsPage  />} />
           <Route path="/associationInterventionPage" element={<AssociationInterventionPage  />} />
           <Route path="/cooperativeInterventionPage" element={<CooperativeInterventionPage  />} />
           <Route path="/interventionProjectsPage" element={<InterventionProjectsPage  />} />
           <Route path="/housingDistributionPage" element={<HousingDistributionPage  />} />
           <Route path="/roofMaterialPage" element={<RoofMaterialPage  />} />
           <Route path="/housingMaterialPage" element={<HousingMaterialPage  />} />
           <Route path="/agriculturalHouseholdsPageProvCom" element={<AgriculturalHouseholdsPageProvCom  />} />
           <Route path="/populationAgeResidencePage" element={<PopulationAgeResidencePage  />} />
           <Route path="/enqueteSatisfaction" element={<EnqueteSatisfaction  />} />
           <Route path="/populationDataPageBuhumuzaButaganzwa" element={<PopulationDataPageBuhumuzaButaganzwa  />} />
          <Route path="/populationDataPageBuhumuzaButihinda" element={<PopulationDataPageBuhumuzaButihinda  />} />
           <Route path="/populationDataPageBuhumuza" element={<PopulationDataPageBuhumuza  />} />
          <Route path="/populationDataPageBujumbura" element={<PopulationDataPageBujumbura  />} />
          <Route path="/populationDataPageBurunga" element={<PopulationDataPageBurunga  />} />
          <Route path="/populationDataPageButanyerera" element={<PopulationDataPageButanyerera  />} />
         <Route path="/populationDataPageGitega" element={<PopulationDataPageGitega  />} />
          <Route path="/populationDataPageBuhumuzaCankuzo" element={<PopulationDataPageBuhumuzaCankuzo  />} />
          <Route path="/populationDataPageBuhumuzaGisagara" element={<PopulationDataPageBuhumuzaGisagara  />} />
          <Route path="/populationDataPageBuhumuzaGisuru" element={<PopulationDataPageBuhumuzaGisuru  />} />
          <Route path="/populationDataPageBuhumuzaRuyigi" element={<PopulationDataPageBuhumuzaRuyigi  />} />
          <Route path="/populationDataPageBujumburaBubanza" element={<PopulationDataPageBujumburaBubanza  />} />
           <Route path="/populationDataPageBuhumuzaMuyinga" element={<PopulationDataPageBuhumuzaMuyinga  />} />
            <Route path="/populationDataPageBujumburaCibitoke" element={<PopulationDataPageBujumburaCibitoke  />} />
            <Route path="/populationDataPageBujumburaIsare" element={<PopulationDataPageBujumburaIsare  />} />
            <Route path="/populationDataPageBujumburaMpanda" element={<PopulationDataPageBujumburaMpanda  />} />
            <Route path="/populationDataPageBujumburaMugina" element={<PopulationDataPageBujumburaMugina  />} />
            <Route path="/populationDataPageBujumburaBukinanyana" element={<PopulationDataPageBujumburaBukinanyana  />} />
            <Route path="/populationDataPageBujumburaMugere" element={<PopulationDataPageBujumburaMugere  />} />
            <Route path="/populationDataPageBujumburaMuhuta" element={<PopulationDataPageBujumburaMuhuta  />} />
            <Route path="/populationDataPageBujumburaMukaza" element={<PopulationDataPageBujumburaMukaza  />} />
            <Route path="/populationDataPageBujumburaNtahangwa" element={<PopulationDataPageBujumburaNtahangwa  />} />
            <Route path="/populationDataPageBujumburaRwibaga" element={<PopulationDataPageBujumburaRwibaga  />} />
            <Route path="/populationDataPageBurungaBururi" element={<PopulationDataPageBurungaBururi  />} />
            <Route path="/populationDataPageBurungaMakamba" element={<PopulationDataPageBurungaMakamba  />} />
            <Route path="/populationDataPageBurungaMatana" element={<PopulationDataPageBurungaMatana />} />
            <Route path="/populationDataPageBurungaMusongati" element={<PopulationDataPageBurungaMusongati  />} />
            <Route path="/populationDataPageBurungaNyanza" element={<PopulationDataPageBurungaNyanza />} />
            <Route path="/populationDataPageBurungaRumonge" element={<PopulationDataPageBurungaRumonge  />} />
            <Route path="/populationDataPageBurungaRutana" element={<PopulationDataPageBurungaRutana  />} />
            <Route path="/populationDataPageButanyereraBusoni" element={<PopulationDataPageButanyereraBusoni  />} />
            <Route path="/populationDataPageButanyereraKayanza" element={<PopulationDataPageButanyereraKayanza />} />
            <Route path="/populationDataPageButanyereraKiremba" element={<PopulationDataPageButanyereraKiremba  />} />
            <Route path="/populationDataPageButanyereraKirundo" element={<PopulationDataPageButanyereraKirundo  />} />
            <Route path="/populationDataPageButanyereraMatongo" element={<PopulationDataPageButanyereraMatongo  />} />
            <Route path="/populationDataPageButanyereraMuhanga" element={<PopulationDataPageButanyereraMuhanga  />} />
            <Route path="/populationDataPageButanyereraNgozi" element={<PopulationDataPageButanyereraNgozi  />} />
            <Route path="/populationDataPageButanyereraTangara" element={<PopulationDataPageButanyereraTangara />} />
             <Route path="/populationDataPageGitegaBugendana" element={<PopulationDataPageGitegaBugendana />} />
            <Route path="/populationDataPageGitegaGishubi" element={<PopulationDataPageGitegaGishubi />} />
            <Route path="/populationDataPageGitegaGitega" element={<PopulationDataPageGitegaGitega/>} />
            <Route path="/populationDataPageGitegaKarusi" element={<PopulationDataPageGitegaKarusi />} />
            <Route path="/populationDataPageGitegaKiganda" element={<PopulationDataPageGitegaKiganda />} />
            <Route path="/populationDataPageGitegaMwaro" element={<PopulationDataPageGitegaMwaro />} />
            <Route path="/populationDataPageGitegaMuramvya" element={<PopulationDataPageGitegaMuramvya />} />
            <Route path="/populationDataPageGitegaNyabihanga" element={<PopulationDataPageGitegaNyabihanga />} />
            <Route path="/populationDataPageGitegaShombo" element={<PopulationDataPageGitegaShombo />} />
            <Route path="/populationDataPageBurundi" element={<PopulationDataPageBurundi />} />
            <Route path="/rapportPaysSoutien" element={<RapportPaysSoutien />} />
            <Route path="/rapportsBilansAlimentaires" element={<RapportsBilansAlimentaires />} />
            <Route path="/moisStatistique2025" element={<MoisStatistique2025 />} />
           <Route path="/rapportModulesAgricoles" element={<RapportModulesAgricoles />} />
            <Route path="/documentsInfographies" element={<DocumentsInfographies />} />
            <Route path="/suiviIndicateurs" element={<SuiviIndicateurs />} />
            <Route path="/data" element={<Data />} />
            <Route path="/clotureMoisStatistique2025" element={<ClotureMoisStatistique2025 />} />
            <Route path="/actualitesEtEvenements" element={<ActualitesEtEvenements />} />
            <Route path="/lancementMoisStatistique2025" element={<LancementMoisStatistique2025 />} />
            <Route path="/cafeStatistiqueRGPH_RGAE" element={<CafeStatistiqueRGPH_RGAE />} />
            <Route path="/premierCongresEtudiantsStatistique" element={<PremierCongresEtudiantsStatistique />} />
            <Route path="/formaFormationPage" element={<FormaFormationPage />} />
            <Route path="/communiquesPresse" element={<CommuniquesPresse />} />
            <Route path="/odinPage" element={<OdinPage />} />
            <Route path="/missionCommunicationPage" element={<MissionCommunicationPage />} />
            <Route path="/formationEnqueteursPage" element={<FormationEnqueteursPage />} />
            <Route path="/indicateurs/pnd" element={<PNDIndicators />} />
            <Route path="/indicateurs/odd" element={<ODDIndicators />} />
            <Route path="/infographie" element={<InfographiePage />} />
            <Route path="/visa" element={<Visa />} />
              <Route path="/atelierValidation" element={<AtelierValidationPage />} />
            



      </Routes>
    </BrowserRouter>
  );
}

export default App;